<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="4" class="pr-1">
                    <input type="text" v-model="searchValue" placeholder="Nama Kantor" class="form-control"/>
                </CCol>
                <CCol sm="3" class="pr-1 pl-1">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleProvinsi()"
                                @blur="toggleCloseVisibleProvinsi()"
                                v-text="selectedItemProvinsi ? selectedItemProvinsi['text'] : ''"
                                v-model="queryProvinsi"
                                @keydown.up="upProvinsi"
                                @keydown.down="downProvinsi"
                                @keydown.enter="selectItemProvinsi"
                                placeholder="Pilih Provinsi"
                        >
                        <div class="popovers" v-show="visibleProvinsi">
                            <div class="options" v-if="matchesProvinsi.length != 0 && queryProvinsi.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesProvinsi"
                                    :key="index"
                                    :class="{ 'selected': (selectedProvinsi == index)}"
                                    @click="itemClickedProvinsi(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="3" class="pr-1 pl-1">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleKota()"
                                @blur="toggleCloseVisibleKota()"
                                v-text="selectedItemKota ? selectedItemKota['text'] : ''"
                                v-model="queryKota"
                                @keydown.up="upKota"
                                @keydown.down="downKota"
                                @keydown.enter="selectItemKota"
                                placeholder="Pilih Kota"
                        >
                        <div class="popovers" v-show="visibleKota">
                            <div class="options" v-if="matchesKota.length != 0 && queryKota.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesKota"
                                    :key="index"
                                    :class="{ 'selected': (selectedKota == index)}"
                                    @click="itemClickedKota(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesKota.length == 0 && queryKota.length == 0 && queryProvinsi.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in dataKota"
                                    :key="index"
                                    :class="{ 'selected': (selectedKota == index)}"
                                    @click="itemClickedKotaBefore(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesKota.length == 0 && queryKota.length != 0 && queryProvinsi.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesKota.length == 0 && queryProvinsi.length == 0">
                                Pilih Provinsi Dahulu
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @maps="goMaps" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="mapsModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Posisi {{nameOffice}}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="mapsModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 8px">
                    <l-map
                        :zoom="zoom"
                        :center="center"
                        style="height: 68.5vh; width: 100%"
                    >
                        <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                        />
                        <l-marker :lat-lng="position.geo">
                            <l-icon>
                                <div class="foto positions">
                                    <b>i</b>
                                </div>
                            </l-icon>
                        </l-marker>
                    </l-map>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <!-- <CRow class="mb-3">
                    <CCol sm="12" class="text-right">
                        <CButton @click="importModal = true" style="float:right; !important" class="btn btn-edit-submit">
                            <span>Import data from excel</span>
                        </CButton>
                    </CCol>
                </CRow> -->
                <CRow>
                    <CCol sm="6">
                        <label>Nama Kantor</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.namaKantor.$model"
                            :class="{ 'is-invalid':$v.namaKantor.$error, 'is-valid': !$v.namaKantor.$invalid }"
                            placeholder="Nama Kantor" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Provinsi</label>
                        <div class="autocomplete">
                            <input type="text"
                                    :class="{ 'is-invalid':$v.queryProvinsi.$error, 'is-valid': !$v.queryProvinsi.$invalid }"
                                    class="form-control"
                                    @click="toggleVisibleProvinsi()"
                                    @blur="toggleCloseVisibleProvinsi()"
                                    v-text="selectedItemProvinsi ? selectedItemProvinsi['text'] : ''"
                                    v-model.trim="$v.queryProvinsi.$model"
                                    @keydown.up="upProvinsi"
                                    @keydown.down="downProvinsi"
                                    @keydown.enter="selectItemProvinsi"
                                    placeholder="Pilih Provinsi"
                            >
                            <div class="popovers" v-show="visibleProvinsi">
                                <div class="options" v-if="matchesProvinsi.length != 0 && queryProvinsi.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesProvinsi"
                                        :key="index"
                                        :class="{ 'selected': (selectedProvinsi == index)}"
                                        @click="itemClickedProvinsi(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Alamat</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.alamat.$model"
                            :class="{ 'is-invalid':$v.alamat.$error, 'is-valid': !$v.alamat.$invalid }"
                            placeholder="Alamat"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Kabupaten/Kota</label>
                        <div class="autocomplete">
                            <input type="text"
                                    :class="{ 'is-invalid':$v.queryKota.$error, 'is-valid': !$v.queryKota.$invalid }"
                                    class="form-control"
                                    @click="toggleVisibleKota()"
                                    @blur="toggleCloseVisibleKota()"
                                    v-text="selectedItemKota ? selectedItemKota['text'] : ''"
                                    v-model.trim="$v.queryKota.$model"
                                    @keydown.up="upKota"
                                    @keydown.down="downKota"
                                    @keydown.enter="selectItemKota"
                                    placeholder="Pilih Kota"
                            >
                            <div class="popovers" v-show="visibleKota">
                                <div class="options" v-if="matchesKota.length != 0 && queryKota.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesKota"
                                        :key="index"
                                        :class="{ 'selected': (selectedKota == index)}"
                                        @click="itemClickedKota(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryKota.length == 0 && queryProvinsi.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in dataKota"
                                        :key="index"
                                        :class="{ 'selected': (selectedKota == index)}"
                                        @click="itemClickedKotaBefore(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryKota.length != 0 && queryProvinsi.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryProvinsi.length == 0">
                                    Pilih Provinsi Dahulu
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Radius (meter)</label>
                        <input 
                            class="form-control" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            v-model.trim="$v.radius.$model"
                            :class="{ 'is-invalid':$v.radius.$error, 'is-valid': !$v.radius.$invalid }"
                            placeholder="Radius" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Latitude</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.latitude.$model"
                            :class="{ 'is-invalid':$v.latitude.$error, 'is-valid': !$v.latitude.$invalid }"
                            placeholder="Latitude"
                            type="text"
                        />
                    </CCol>
                </CRow>
                 <CRow>
                    <CCol sm="6">
                        <label>Image Office</label>
                        <div v-if="urlImage == '' || urlImage == 'null'">
                            <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                            <div class="cards-image">+</div>
                        </div>
                        <div v-else>
                            <img :src="urlImage" width="56" height="56" />
                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Longitude</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.longitude.$model"
                            :class="{ 'is-invalid':$v.longitude.$error, 'is-valid': !$v.longitude.$invalid }"
                            placeholder="Longitude" 
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" style="float:left;" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" style="float:left;" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>

    <CModal
        size="xl"
        :centered="true"
        color="white"
        :show.sync="importModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Import Data Kantor dari excel</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="importModal = false, filesImport = '', dataImport = []" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow class="mb-3">
                    <CCol sm="6">
                        <label class="params">
                            Unduh Template File Excel Data Kantor
                        </label><br/>
                        <img style="cursor:pointer" :src="downloadIcon" title="Unduh Template Data Kantor" width="30px" height="30px"/>
                    </CCol>
                    <CCol sm="6">
                        <label class="params">
                            Unggah Data Kantor (file: Ms. Excel)
                        </label>
                        <input ref="filesImport" v-on:change="onFileChangeImport" class="form-control" style="cursor:pointer" type="file" accept=".xls, .xlsx," />
                    </CCol>
                </CRow>
                <CRow class="mt-2 mb-5" v-if="dataImport.length != 0">
                    <CCol sm="12">
                        <table class="table-responsive">
                            <thead>
                                <tr>
                                    <th>Nama Kantor</th>
                                    <th>Provinsi</th>
                                    <th>Kota/Kabupaten</th>
                                    <th>Alamat</th>
                                    <th>Radius</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                </tr>
                            </thead>
                            <tbody v-if="dataImport.length != 0">
                                <tr v-for="(body, id) in dataImport" :key="id">
                                    <td>{{body.nama}}</td>
                                    <td>{{body.provinsi}}</td>
                                    <td>{{body.kota}}</td>
                                    <td>{{body.alamat}}</td>
                                    <td>{{body.radius}}</td>
                                    <td>{{body.latitude}}</td>
                                    <td>{{body.longitude}}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td class="text-center" colspan="7">
                                        {{errImport}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
                <CRow class="mb-3 mt-2" v-if="dataImport.length != 0">
                    <CCol sm="12">
                        <CButton @click="importModal = false, filesImport = [], dataImport = []" type="button" style="float:right" class="btn btn-cancel mr-2">Batal</CButton>
                        <CButton @click="submitForm()" style="float:right" class="btn btn-edit-submit">
                            <span v-if="loading == false">Submit</span>
                            <CSpinner v-else color="default" size="sm"/>
                        </CButton>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tables'
import {DataApi, DataApiUpload} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { latLng, icon } from "leaflet";

export default {
    components: {
        ModelSelect,
        Tables,
        LMap,
        LTileLayer,
        LMarker,
        LIcon
    },
    mixins: [validationMixin],
    validations: {
        namaKantor: {
            required
        },
        alamat: {
            required
        },
        radius: {
            required
        },
        latitude: {
            required: (function() {
                if(this.valueValidateLat == true) {
                    return true
                } else {
                    return false
                }
            })
        },
        longitude: {
            required: (function() {
                if(this.valueValidateLong == true) {
                    return true
                } else {
                    return false
                }
            })
        },
        queryProvinsi: {
            required
        },
        queryKota: {
            required
        }
    },
    data() {
        return {
            titleProvinsi:"Pilih Provinsi",
            selectedItemProvinsi: null,
            selectedProvinsi: 0,
            queryProvinsi: '',
            visibleProvinsi: false,

            titleKota:"Pilih Kota",
            selectedItemKota: null,
            selectedKota: 0,
            queryKota: '',
            visibleKota: false,

            success: true,
            importModal: false,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama Kantor', 'Alamat', 'Kota', 'Provinsi', 'Latitude', 'Longitude', 'Radius', 'Action'],
            dataTd: [['urlFoto', 'nama'], 'alamat', 'kota', 'provinsi', 'latitude', 'longitude', 'radius', 'act'],
            styleTable: ['200px', '120px', '120px', '120px', '130px', '130px', '110px', '150px'],
            classReload: 'reloadOff',
            datas: [],
            dataProvinsi: [],
            dataKota: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            namaKantor: '',
            alamat: '',
            id: 0,
            zona: 0,
            radius: '',
            latitude: '',
            longitude: '',
            urlImage: '',
            showImage: '',
            urlPath: '',
            pusat: 'T',

            tipe: 'c',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',
            organisasi: '',
            lvl: '',

            // error
            errorMessage: '',
            valueValidateLong: false,
            valueValidateLat: false,

            filesImport: [],
            errImport: '',
            dataImport: [],

            // maps
            mapsModal: false,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 15,
            center: [-6.234970, 106.822545],
            foto: null,
            position: {
                items: null,
                geo: [0,0]
            },
            nameOffice: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        latitude() {
            this.validationLat()
        },
        longitude() {
            this.validationLong()
        },
        queryProvinsi() {
            this.getProvince()
            this.dataKota = []
            if(this.tipe == 'C') {
                this.queryKota = ''
            }
            this.flagSearch = true
        },
        queryKota() {
            this.getCity('null')
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
        matchesProvinsi() {
            if (this.queryProvinsi == '') {
                return [];
            }
            return this.dataProvinsi.filter((item) => item['text'].toLowerCase().includes(this.queryProvinsi.toLowerCase()))
        },
        matchesKota() {
            if (this.queryKota == '') {
                return [];
            }
            return this.dataKota.filter((item) => item['text'].toLowerCase().includes(this.queryKota.toLowerCase()))
        },
    },
    methods: {
        toggleVisibleProvinsi() {
            this.visibleProvinsi = true;
        },
        hideProvinsi() {
            this.visibleProvinsi = false;
        },
        toggleCloseVisibleProvinsi() {
            setTimeout(this.hideProvinsi, 1000);
        },
        itemClickedProvinsi(index) {
            this.selectedProvinsi = index;
            this.selectItemProvinsi();
        },
        selectItemProvinsi() {
            if (!this.matchesProvinsi.length) {
            return;
            }
            this.selectedItemProvinsi = this.matchesProvinsi[this.selectedProvinsi];
            this.queryProvinsi = this.selectedItemProvinsi.text
            this.getCity('null')
            this.visibleProvinsi = false;
            if (this.shouldReset) {
            this.queryProvinsi = '';
            this.selectedProvinsi = 0;
            }
        },
        upProvinsi() {
            if (this.selectedProvinsi == 0) {
            return;
            }
            this.selectedProvinsi -= 1;
            this.scrollToItemProvinsi();
        },
        downProvinsi() {
            if (this.selectedProvinsi >= this.matchesProvinsi.length - 1) {
            return;
            }
            this.selectedProvinsi += 1;
            this.scrollToItemProvinsi();
        },
        scrollToItemProvinsi() {
            this.$refs.optionsList.scrollTop = this.selectedProvinsi * this.itemHeight;
        },
        
        toggleVisibleKota() {
            this.visibleKota = true;
        },
        hideKota() {
            this.visibleKota = false;
        },
        toggleCloseVisibleKota() {
            setTimeout(this.hideKota, 1000);
        },
        itemClickedKota(index) {
            this.selectedKota = index;
            this.selectItemKota();
        },
        itemClickedKotaBefore(index) {
            this.selectedKota = index;
            this.selectedItemKota = this.dataKota[this.selectedKota];
            this.queryKota = this.selectedItemKota.text
            this.visibleKota = false;
        },
        selectItemKota() {
            if (!this.matchesKota.length) {
            return;
            }
            this.selectedItemKota = this.matchesKota[this.selectedKota];
            this.queryKota = this.selectedItemKota.text
            this.visibleKota = false;
            if (this.shouldReset) {
            this.queryKota = '';
            this.selectedKota = 0;
            }
        },
        upKota() {
            if (this.selectedKota == 0) {
            return;
            }
            this.selectedKota -= 1;
            this.scrollToItemKota();
        },
        downKota() {
            if (this.selectedKota >= this.matchesKota.length - 1) {
            return;
            }
            this.selectedKota += 1;
            this.scrollToItemKota();
        },
        scrollToItemKota() {
            this.$refs.optionsList.scrollTop = this.selectedKota * this.itemHeight;
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            if(this.datas.length != 0) {
                let provinsi = this.queryProvinsi
                let kota = this.queryKota
                let limit = this.totalRow
                let nama = this.searchValue
                let page = 1
                let pusat = ''

                let payload = {
                    kota: kota,
                    limit: limit,
                    nama: nama,
                    pageIn: page,
                    provinsi: provinsi,
                    pusat: pusat
                }
                DataApi.post("/export/kantor/get", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Daftar Kantor')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let provinsi = this.queryProvinsi
            let kota = this.queryKota
            let limit = this.size
            let nama = this.searchValue
            let page = this.page
            let pusat = ''

            let payload = {
                kota: kota,
                limit: limit,
                nama: nama,
                pageIn: page,
                provinsi: provinsi,
                pusat: pusat
            }
            DataApi.post("kantor/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.queryProvinsi = ''
            this.queryKota = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        getProvince() {
            let payload = {
                provinsi: this.queryProvinsi
            }
            DataApi.post("kantor/get/provinsi", payload)
            .then(res => {
                this.dataProvinsi = []
                let response = res.data.data
                var i;
                for(i=0;i<response.length;i++) {
                    let values = {
                        value: response[i],
                        text: response[i]
                    }
                    this.dataProvinsi.push(values)
                }
            })
        },
        getCity(val) {
            if(val == 'null') {
                if(this.queryProvinsi.length == 0) {
                    this.dataKota = []
                } else {
                    let payload = {
                        kabkota: this.queryKota,
                        provinsi: this.queryProvinsi
                    }
                    DataApi.post("kantor/get/kabkota", payload)
                    .then(res => {
                        this.dataKota = []
                        let response = res.data.data
                        var i;
                        for(i=0;i<response.length;i++) {
                            let values = {
                                value: response[i].kabkota,
                                text: response[i].kabkota
                            }
                            this.dataKota.push(values)
                        }
                    })
                }
            } else {
                if(this.queryProvinsi.length == 0) {
                    this.dataKota = []
                } else {
                    let payload = {
                        kabkota: val,
                        provinsi: this.queryProvinsi
                    }
                    DataApi.post("kantor/get/kabkota", payload)
                    .then(res => {
                        this.dataKota = []
                        let response = res.data.data
                        var i;
                        for(i=0;i<response.length;i++) {
                            let values = {
                                value: response[i].kabkota,
                                text: response[i].kabkota
                            }
                            this.dataKota.push(values)
                        }
                        this.queryKota = val
                    })
                }
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
                if(this.tipe == 'c') {
                    this.queryProvinsi = ''
                    this.queryKota = ''
                }
            } else {
                this.goArea = true
                this.namaKantor = ''
                this.id = 0
                this.alamat = ''
                this.queryProvinsi = ''
                this.queryKota = ''
                this.radius = ''
                this.latitude = ''
                this.longitude = ''
                this.urlImage = ''
                this.urlPath = ''
                this.pusat = 'T'
                this.showImage = ''
                this.tipe = 'c'
                this.getProvince()
                this.$v.$reset()
            }
        },
        goSave() {
            let nama = this.namaKantor
            let id = this.id
            let alamat = this.alamat
            let provinsi = this.queryProvinsi
            let kota = this.queryKota
            let zona = this.zona
            let radius = this.radius
            let latitude = this.latitude
            let longitude = this.longitude
            let image = this.urlPath
            let tipe = this.tipe
            let pusat = this.pusat

            let payload ={
                alamat: alamat,
                kota: kota,
                id: id,
                latitude: latitude,
                longitude: longitude,
                pusat: pusat,
                nama: nama,
                provinsi: provinsi,
                radius: radius,
                urlFoto: image,
                zona: zona,
                tipe: tipe
            }
            DataApi.post("kantor/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.alamat = generate.alamat
            this.id = generate.id
            this.latitude = generate.latitude
            this.longitude = generate.longitude
            this.namaKantor = generate.nama
            this.pusat = generate.pusat
            this.radius = generate.radius
            if(generate.urlFoto == 'null' ||
            generate.urlFoto == null ||
            generate.urlFoto == '' ||
            generate.urlFoto == undefined) {
                this.urlImage = 'null'
            } else {
                this.urlImage = generate.urlFoto
            }
            this.queryProvinsi = generate.provinsi
            this.getCity(generate.kota)
            this.tipe = 'u'
            this.moving()
        },

        /**
         * IMAGE
         */
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave()
                    } else {
                        alert('Upload Photo Failed !')
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave()
            } else {
                this.urlPath = this.urlImage
                this.goSave()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        /**
         * VALIDATE
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.saveImage()
                this.loading = true
            }
        },
        validationLat() {
            let reg = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
            let check = reg.test(this.latitude)
            if(check == false) {
                this.valueValidateLat = false
            } else {
                this.valueValidateLat = true
            }
        },
        validationLong() {
            let reg = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
            let check = reg.test(this.longitude)
            if(check == false) {
                this.valueValidateLong = false
            } else {
                this.valueValidateLong = true
            }
        },

        /**
         * IMPORT XLS
         * 
         */
        onFileChangeImport(e) {
            this.dataImport = []
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.filesImport = files[0];

            const formData = new FormData();
            formData.append("file", this.filesImport)
            DataApi.post("import/kantor", formData)
            .then(res => {
                let temp = res.data
                if(temp.success == true) {
                    this.dataImport = temp.data
                    this.errImport = ''
                } else {
                    this.dataImport = []
                    this.errImport = 'Maaf, Import file gagal.'
                }
            })
            
        },

        /**
         * MAPS
         */
        goMaps(value) {
            let col = this.datas[value]
            this.center = [col.latitude, col.longitude]
            this.position.geo = [col.latitude, col.longitude]
            this.position.items
            this.mapsModal = true
            this.nameOffice = col.nama
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
        this.getProvince()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.foto{
  padding: 5px;
  border-radius: 50%;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 40px;
  height: 40px;
  margin: 0 !important;
  color: white;
  font-size: 1.25rem;
}
.positions {
  background-color: #0E86D4;
}
</style>
